import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

/**
 * React Query client, deliberately separate from the Web3 stack.
 *
 * This used to live in config/web3modal.ts, which meant reaching for a
 * plain data-fetching cache dragged in WalletConnect, wagmi, and the
 * Web3Modal singleton — all of which self-initialize at module scope. Data
 * caching is domain-neutral infrastructure; wallets are an optional
 * extension. Keeping them in the same module made the second one
 * unavoidable (EP-001A / D-06).
 */
export const queryClient = new QueryClient();

export { QueryClientProvider };
